
import { Component, Prop, Vue } from 'vue-property-decorator'
import Loader from '@/components/common/buttons/BtnLoader.vue'
import Icon from '@/components/common/icon/Icon.vue'
import { enterKeyPressHolder } from '@/lib/utils/event'

@Component({
  components: {
    Icon,
    Loader
  }
})
export default class MyComponent extends Vue {
  @Prop({ type: String, default: '' }) label!: string
  @Prop({ type: String, default: 'l' }) size!: string
  @Prop({ type: String, default: 'orange' }) theme!: string
  @Prop({ type: String, default: 'm' }) sizeLoader!: string
  @Prop({ type: String, default: '' }) href!: string
  @Prop({ type: Boolean, default: false }) showLoader!: boolean
  @Prop({ type: Boolean, default: false }) shouldHoldKeyPress!: boolean
  @Prop({ type: Object, default: () => ({}) }) icon!: {
    position: string
    name: string
  }

  enterHold: any = null

  created() {
    if (this.shouldHoldKeyPress) {
      this.enterHold = enterKeyPressHolder()
    }
  }

  mounted() {
    if (this.enterHold) {
      this.enterHold.bind(this.emitClickEvent)
    }
  }

  beforeDestroy() {
    if (this.enterHold) {
      this.enterHold.unbind()
    }
  }

  handleClick(ev: Event) {
    if (!this.href) {
      ev.preventDefault()
    }
  }

  emitClickEvent(ev: Event) {
    this.$emit('click', ev)
  }
}
